export interface Tokens {
  access: string
  refresh: string
}

const USER_KEY = 'USER_KEY'

export function getTokens(): Tokens | null {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function getAccessToken(): string | null {
  return getTokens()?.access ?? null
}

export function saveTokens(tokens: Tokens): void {
  localStorage.setItem(USER_KEY, JSON.stringify(tokens))
}

export function clearTokens(): void {
  localStorage.removeItem(USER_KEY)
}

export function isAuthenticated(): boolean {
  return !!getTokens()?.access
}
